import React, { useRef } from 'react';
import { PointLight } from 'three';

import { useTeamMemberContext } from 'context/Team';
import Louie from '@/3D/models/Louie';
import Ryan from '@/3D/models/Ryan';
import Alex from '@/3D/models/Alex';
import Anya from '@/3D/models/Anya';
import Brett from '@/3D/models/Brett';
import Corinne from '@/3D/models/Corinne';
import Emma from '@/3D/models/Emma';
import Matt from '@/3D/models/Matt';
import Gretch from '@/3D/models/Gretch';
import Marty from '@/3D/models/Marty';
import Sylvie from '@/3D/models/Sylvie';
import Haseeb from '@/3D/models/Haseeb';
import Soyeon from '@/3D/models/Soyeon';
import Keely from '@/3D/models/Keely';
import Marco from '@/3D/models/Marco';
import Lynn from '@/3D/models/Lynn';
import Alise from '@/3D/models/Alise';
import Generic from '@/3D/models/Generic';
import Siobahn from '@/3D/models/Siobahn';
import Bjoern from '@/3D/models/Bjoern';
import Dani from '@/3D/models/Dani';
import Dave from '@/3D/models/Dave';
import Eric from '@/3D/models/Eric';
import Logo from '@/3D/models/Logo';

const inConfig = { mass: 1, tension: 100, friction: 20, precision: 0.001 };
const outConfig = { mass: 10, tension: 500, friction: 100, precision: 0.001, velocity: 0.01 };

const FBOScene: React.FC = () => {
  const pointLight = useRef<PointLight>(null!);
  const optedOut: (string | undefined)[] = ['Camille Marzella'];

  const {
    config: { currentTeamMember }
  } = useTeamMemberContext();

  return (
    <>
      {/* <ambientLight intensity={1000} /> */}
      <pointLight ref={pointLight} intensity={300000000} position={[0, 30, 30]} />
      <pointLight ref={pointLight} intensity={300000} position={[-10, 0, -30]} />
      {/* models */}
      <>
        <Logo active={!currentTeamMember} inConfig={inConfig} outConfig={outConfig} />
        <Louie
          active={currentTeamMember?.name === 'Louie Williford'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Ryan
          active={currentTeamMember?.name === 'Ryan Simpson'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Alex
          active={currentTeamMember?.name === 'Alex Christie'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Anya
          active={currentTeamMember?.name === 'Anya Sherriuble'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Brett
          active={currentTeamMember?.name === 'Brett Cimbalik'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Corinne
          active={currentTeamMember?.name === 'Corinne Resch'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Emma
          active={currentTeamMember?.name === 'Emma Sims'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Matt
          active={currentTeamMember?.name === 'Matt Harlan'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Gretch
          active={currentTeamMember?.name === 'Gretchen Robertson'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Marty
          active={currentTeamMember?.name === 'Marty Warfel'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Sylvie
          active={currentTeamMember?.name === 'Sylvia Maria Rosa'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Haseeb
          active={currentTeamMember?.name === 'Haseeb Khan'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Soyeon
          active={currentTeamMember?.name === 'Soyeon Kim'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Keely
          active={currentTeamMember?.name === 'Keely Dowd'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Marco
          active={currentTeamMember?.name === 'Marco Torres'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Lynn
          active={currentTeamMember?.name === 'Lynn Hurley'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Alise
          active={currentTeamMember?.name === 'Alise Jarmusz'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Generic
          active={optedOut.includes(currentTeamMember?.name)}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Siobahn
          active={currentTeamMember?.name === 'Siobahn Schuck'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Bjoern
          active={currentTeamMember?.name === 'Bjoern Sagstad'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Dani
          active={currentTeamMember?.name === 'Dani Rev'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Dave
          active={currentTeamMember?.name === 'Dave Lashinsky'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
        <Eric
          active={currentTeamMember?.name === 'Eric Dennis'}
          inConfig={inConfig}
          outConfig={outConfig}
        />
      </>
    </>
  );
};

export default FBOScene;
